import { render, staticRenderFns } from "./Kemitraan.vue?vue&type=template&id=569ec291"
import script from "./Kemitraan.vue?vue&type=script&lang=js"
export * from "./Kemitraan.vue?vue&type=script&lang=js"
import style0 from "./Kemitraan.vue?vue&type=style&index=0&id=569ec291&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports